// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Request from './request'
import Router from 'vue-router'
//main.js中
import './utils/flexible'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//引入自定义组件
import companyBar from './components/companyBar.vue'
import headerBar from './components/headerBar.vue'
Vue.component('companyBar',companyBar)
Vue.component('headerBar',headerBar)

/*引入mint ui*/
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'
Vue.use(Mint);
/************/

//引入时间格式
import moment from 'moment'
Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dataStr).format(pattern)
})


//上拉加载.下拉刷新
import VueScroller from 'vue-scroller'
Vue.use(VueScroller)


Vue.prototype.$request = Request;
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js